const createRegisterComponentMessage = (info) => ({
  type: "builder.registerComponent",
  data: serializeIncludingFunctions(info)
});
const serializeFn = (fnValue) => {
  const fnStr = fnValue.toString().trim();
  const isArrowWithoutParens = /^[a-zA-Z0-9_]+\s*=>/i.test(fnStr);
  const appendFunction = !fnStr.startsWith("function") && !fnStr.startsWith("async") && !fnStr.startsWith("(") && !isArrowWithoutParens;
  return `return (${appendFunction ? "function " : ""}${fnStr}).apply(this, arguments)`;
};
function serializeIncludingFunctions(info) {
  return JSON.parse(JSON.stringify(info, (key, value) => {
    if (typeof value === "function")
      return serializeFn(value);
    return value;
  }));
}
export {
  createRegisterComponentMessage,
  serializeIncludingFunctions
};
